import PartWiseAnalysis from "./PartWiseAnalysis";

export default PartWiseAnalysis;
